/* =============================================================
   KM Tools — Negative Rake Drill Bit Sets · Landing page JS
   Reads variant data from window.NR_SKUS (injected by Liquid)
   ============================================================= */

(function () {
  'use strict';

  const root = document.getElementById('negative-rake-landing');
  if (!root) return;

  const SKUS = window.NR_SKUS || {};
  const SIZE_DATA = window.NR_SIZE_DATA || {};

  // -------- Picker state ----------
  let currentUnit = 'imperial';
  let selectedSku = null;

  // Pick first available sku as default
  const defaultOrder = ['imp-15', 'imp-8', 'met-15', 'met-8'];
  for (const id of defaultOrder) {
    if (SKUS[id] && SKUS[id].variantId) { selectedSku = id; break; }
  }
  if (!selectedSku) selectedSku = 'imp-15';

  // -------- Unit toggle ----------
  const unitToggle = root.querySelector('#unit-toggle');
  const skuGrid = root.querySelector('#sku-grid');

  if (unitToggle && skuGrid) {
    unitToggle.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      currentUnit = btn.dataset.unit;
      [...unitToggle.querySelectorAll('button')].forEach(b => b.classList.toggle('active', b === btn));
      [...skuGrid.querySelectorAll('.sku')].forEach(card => {
        card.style.display = card.dataset.unit === currentUnit ? '' : 'none';
      });
      // select first visible sku (prefer 15pc)
      const prefer = currentUnit === 'imperial' ? 'imp-15' : 'met-15';
      const fallback = currentUnit === 'imperial' ? 'imp-8' : 'met-8';
      selectSku(SKUS[prefer] && SKUS[prefer].variantId ? prefer : fallback);
    });
  }

  // -------- Select SKU ----------
  function selectSku(id) {
    if (!SKUS[id]) return;
    selectedSku = id;
    if (skuGrid) {
      [...skuGrid.querySelectorAll('.sku')].forEach(c => c.classList.toggle('selected', c.dataset.sku === id));
    }
    const data = SKUS[id];
    const setText = (sel, val) => { const el = root.querySelector(sel); if (el && val != null) el.textContent = val; };
    const setSrc = (sel, val) => { const el = root.querySelector(sel); if (el && val) el.src = val; };
    setText('#atc-name', data.name);
    setText('#atc-vari', data.vari);
    setText('#atc-price', data.priceFormatted);
    setSrc('#atc-thumb-img', data.img);
    // Update sticky bar's compare-at (if any)
    const compare = root.querySelector('#atc-compare');
    if (compare) compare.style.display = data.compareAtFormatted ? '' : 'none';
    if (compare && data.compareAtFormatted) compare.textContent = data.compareAtFormatted;
  }

  if (skuGrid) {
    skuGrid.addEventListener('click', (e) => {
      const card = e.target.closest('.sku');
      if (!card) return;
      selectSku(card.dataset.sku);
    });
  }
  selectSku(selectedSku);

  // -------- Size chart tabs ----------
  const scTabs = root.querySelector('#sc-tabs');
  const scTable = root.querySelector('#sc-table');
  function renderSizeChart(tabId) {
    if (!scTable || !SIZE_DATA[tabId]) return;
    const data = SIZE_DATA[tabId];
    const tbody = scTable.querySelector('tbody');
    const thead = scTable.querySelector('thead');
    thead.innerHTML = '<tr>' + data.headers.map((h, i) =>
      `<th class="${i >= 3 ? 'right' : ''}">${h}</th>`
    ).join('') + '</tr>';
    tbody.innerHTML = data.rows.map(r =>
      `<tr>
        <td>${r[0]}</td>
        <td><strong>${r[1]}</strong></td>
        <td>${r[2]}</td>
        <td class="right ${r[3] ? 'yes' : 'no'}">${r[3] ? '●' : '—'}</td>
        <td class="right ${r[4] ? 'yes' : 'no'}">${r[4] ? '●' : '—'}</td>
      </tr>`
    ).join('');
  }
  if (scTabs) {
    scTabs.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      [...scTabs.querySelectorAll('button')].forEach(b => b.classList.toggle('active', b === btn));
      renderSizeChart(btn.dataset.tab);
    });
    renderSizeChart('imp-15');
  }

  // -------- Sticky ATC bar ----------
  const atc = root.querySelector('#atc-bar');
  const shopSec = root.querySelector('#shop');
  const heroSec = root.querySelector('.hero');
  function checkAtc() {
    if (!atc || !shopSec || !heroSec) return;
    const heroBottom = heroSec.getBoundingClientRect().bottom;
    const shopRect = shopSec.getBoundingClientRect();
    const show = heroBottom < 0 &&
      !(shopRect.top < window.innerHeight * 0.6 && shopRect.bottom > window.innerHeight * 0.3);
    atc.classList.toggle('show', show);
  }
  window.addEventListener('scroll', checkAtc, { passive: true });
  window.addEventListener('resize', checkAtc, { passive: true });
  checkAtc();

  // -------- Add to cart ----------
  async function addToCart(variantId, quantity) {
    if (!variantId) return;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      });
      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.description || 'Could not add to cart.');
      }
      // Try theme's cart drawer event, then fall back to /cart
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:added'));
      // Open cart drawer if theme exposes it
      const drawerOpeners = [
        '[data-cart-drawer-toggle]',
        '#CartDrawer-Toggle',
        '[aria-controls="CartDrawer"]'
      ];
      let opened = false;
      for (const sel of drawerOpeners) {
        const el = document.querySelector(sel);
        if (el) { el.click(); opened = true; break; }
      }
      if (!opened) window.location.href = '/cart';
    } catch (err) {
      console.error('[Negative Rake] Add to cart failed:', err);
      alert('Couldn\u2019t add to cart: ' + err.message);
    }
  }

  const atcCta = root.querySelector('#atc-cta');
  if (atcCta) {
    atcCta.addEventListener('click', () => {
      const d = SKUS[selectedSku];
      if (!d || !d.variantId) { alert('This set isn\u2019t set up yet. Please pick another option.'); return; }
      atcCta.disabled = true;
      atcCta.dataset.label = atcCta.textContent;
      atcCta.textContent = 'Adding\u2026';
      addToCart(d.variantId, 1).finally(() => {
        atcCta.disabled = false;
        if (atcCta.dataset.label) atcCta.textContent = atcCta.dataset.label;
      });
    });
  }

  // Per-card "Add to Cart" buttons (each SKU card)
  root.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const sku = btn.dataset.addToCart;
      const d = SKUS[sku];
      if (!d || !d.variantId) { alert('This set isn\u2019t set up yet.'); return; }
      btn.disabled = true;
      const orig = btn.textContent;
      btn.textContent = 'Adding\u2026';
      addToCart(d.variantId, 1).finally(() => {
        btn.disabled = false;
        btn.textContent = orig;
      });
    });
  });

  // -------- Video modal ----------
  const modal = root.querySelector('#nr-video-modal');
  const modalInner = root.querySelector('#nr-video-modal-inner');
  function openVideo(src, vertical) {
    if (!modal || !modalInner) return;
    modalInner.classList.toggle('vertical', !!vertical);
    if (!src) {
      modalInner.innerHTML = '<div style="display:grid;place-items:center;color:#fff;font-family:Manrope;padding:40px;text-align:center;">Video coming soon \u2014 hook this up in Shopify section settings.</div>';
    } else if (/youtube\.com|youtu\.be|vimeo\.com/.test(src)) {
      // Embed url
      let embed = src;
      const ytMatch = src.match(/(?:v=|youtu\.be\/|embed\/)([\w-]+)/);
      if (ytMatch && src.includes('youtube')) embed = 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1';
      else if (src.includes('youtu.be')) embed = 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1';
      const vmMatch = src.match(/vimeo\.com\/(\d+)/);
      if (vmMatch) embed = 'https://player.vimeo.com/video/' + vmMatch[1] + '?autoplay=1';
      modalInner.innerHTML = '<iframe src="' + embed + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    } else {
      modalInner.innerHTML = '<video src="' + src + '" controls autoplay playsinline></video>';
    }
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeVideo() {
    if (!modal || !modalInner) return;
    modal.classList.remove('show');
    modalInner.innerHTML = '';
    modalInner.classList.remove('vertical');
    document.body.style.overflow = '';
  }
  if (modal) {
    modal.addEventListener('click', (e) => { if (e.target === modal) closeVideo(); });
    const closeBtn = modal.querySelector('.nr-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeVideo);
    window.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeVideo(); });
  }

  root.querySelectorAll('[data-video]').forEach(btn => {
    btn.addEventListener('click', () => {
      const which = btn.dataset.video;
      const src = (window.NR_VIDEOS || {})[which] || '';
      const vertical = which && which.indexOf('vert') > -1;
      openVideo(src, vertical);
    });
  });

  // -------- Inline autoplay video controls (comparison block) --------
  // 1. Pause when scrolled off-screen, resume when scrolled back into view.
  // 2. Unmute button toggles the muted state and updates the icon.
  root.querySelectorAll('[data-nr-autoplay]').forEach(frame => {
    const vid = frame.querySelector('video');
    if (vid) {
      // Pause/play on visibility
      const visIO = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            vid.play().catch(() => {});
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.25 });
      visIO.observe(frame);

      // Mute toggle
      const muteBtn = frame.querySelector('[data-nr-mute]');
      if (muteBtn) {
        const mutedIco = muteBtn.querySelector('[data-muted]');
        const unmutedIco = muteBtn.querySelector('[data-unmuted]');
        muteBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          vid.muted = !vid.muted;
          if (vid.muted) {
            mutedIco && (mutedIco.hidden = false);
            unmutedIco && (unmutedIco.hidden = true);
            muteBtn.setAttribute('aria-label', 'Unmute');
          } else {
            mutedIco && (mutedIco.hidden = true);
            unmutedIco && (unmutedIco.hidden = false);
            muteBtn.setAttribute('aria-label', 'Mute');
            // If autoplay was blocked, kick it after the gesture
            vid.play().catch(() => {});
          }
        });
      }
    }
  });

  // -------- Reveal on scroll ----------
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.15 });
  root.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();
